import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/use-i18n';
import { Icon as PtIcon } from 'patsnap-biz';
import { Popover } from 'element-ui';
import '@patsnap-ui/icon/assets/CompareGradient.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareWordingTips',
  setup(__props) {

const ElPopover = Popover;

const { t } = useI18n();

return { __sfc: true,ElPopover, t, PtIcon }
}

})